<template>
	<div>
		<header-page
			name="companies-new"
			:title="title"
		/>
		<form-sidebar>
			<v-form class="form">
				<v-layout wrap mt-3>
					<v-flex xs12 py-0>
						<label class="title-section">Datos de la Empresa</label>
					</v-flex>
					<v-flex xs12 pt-0 mb-3>
						<v-divider></v-divider>
					</v-flex>
				</v-layout>
				<v-layout wrap justify-space-between>
					<v-flex xs12 md6>
						<v-layout row mb-1>
							<v-flex xs12>
								<BaseInput
									label="Nombre de la Empresa"
									:height="38"
									v-model="$v.model.name.$model"
								>
									<small
										slot="error"
										v-show="$v.$anyDirty && !$v.model.name.required"
									>El nombre es requerido</small>
								</BaseInput>
							</v-flex>
						</v-layout>
						<v-layout row mb-1>
							<v-flex xs12>
								<BaseInput
									label="Representante Legal"
									:height="38"
									v-model="model.legalRepresentative"
								/>
							</v-flex>
						</v-layout>
						<v-layout row wrap justify-space-between mb-3>
							<v-flex xs12 md6>
								<BaseInput
									label="Ruc"
									:height="38"
									type="number"
									v-model="$v.model.documentNumber.$model"
									@blur="setExternalId"
								/>
								<span class="error--text caption" v-show="$v.$anyDirty && !$v.model.documentNumber.required">
									El número de RUC es requerido
								</span>
								<span class="error--text caption" v-show="$v.$anyDirty && !$v.model.documentNumber.maxLength">
									El RUC solo puede tener 13 digitos
								</span>
							</v-flex>
							<v-flex xs12 md6>
								<BaseDate
									type="date"
									label="Fecha Inicio"
									:height="38"
									v-model="model.startDateOperations"
								/>
							</v-flex>
						</v-layout>
					</v-flex>
					<v-flex xs12 md6>
						<v-layout row wrap mb-1>
							<v-flex xs12 md6>
								<BaseSelect
									label="Actividades"
									item-text="name"
									item-value="id"
									:height="38"
									:items="activities"
									v-model="model.activityId"
								/>
							</v-flex>
							<v-flex xs12 md6>
								<BaseSelect
									label="Ciudades"
									item-text="name"
									item-value="id"
									:height="38"
									:items="cities"
									v-model="model.cityId"
								/>
							</v-flex>
						</v-layout>
						<v-layout row wrap mb-3>
							<v-flex xs12 md6>
								<BaseSelect
									label="Tipo de Contribuyente"
									item-text="name"
									item-value="id"
									:height="38"
									:items="typeTaxpayers"
									v-model="model.typeTaxpayerId"
								/>
							</v-flex>
							<v-flex xs12 md6>
								<BaseSelect
									v-if="externalOptions.length > 1"
									label="Empresa comercial vinculada"
									item-text="label"
									item-value="id"
									:height="38"
									:items="externalOptions"
									:is-loading="externalLoading"
									v-model="model.externalId"
								/>
								<BaseInput
									v-else
									readonly
									label="Código Externo"
									:height="38"
									v-model="model.externalId"
								/>
								<small v-if="externalLoading" class="external-company-hint caption info--text" role="status">
									Buscando empresas comerciales asociadas...
								</small>
								<small v-else-if="requiresExternalSelection" class="external-company-hint caption error--text" role="status">
									Selecciona la empresa comercial que corresponde a este RUC.
								</small>
							</v-flex>
						</v-layout>
					</v-flex>
				</v-layout>
				<v-layout wrap mt-3>
					<v-flex xs12 md6>
						<v-layout row wrap>
							<v-flex xs12 py-0>
								<label class="title-section">Datos Adicionales</label>
							</v-flex>
							<v-flex xs12 pt-0 pb-3>
								<v-divider></v-divider>
							</v-flex>
							<v-flex xs12>
								<v-layout row justify-space-between align-start>
									<v-flex xs5>
										<BaseInput
											label="Nombre"
											:height="38"
											v-model="additionalData.name"
										/>
									</v-flex>
									<v-flex xs5>
										<BaseInput
											label="Valor"
											type="number"
											:height="38"
											v-model="additionalData.value"
											@keypress.enter="addData('additionalData')"
										/>
									</v-flex>
									<v-flex xs1>
										<AddButton
											class="add-btn-container mr-2"
											@click="addData('additionalData')"
										/>
									</v-flex>
								</v-layout>
							</v-flex>
						</v-layout>
						<v-layout wrap align-center justify-space-between>
							<v-flex xs12 style="height:78px"
								v-for="(modelData, index) in model.additionalData"
								:key="modelData.id">
								<v-layout wrap align-start justify-space-between>
									<v-flex xs5>
										<BaseInput
											:height="38"
											label="Nombre"
											v-model="modelData.name"
										/>
									</v-flex>
									<v-flex xs5>
										<BaseInput
											:height="38"
											label="Valor"
											v-model="modelData.value"
										/>
									</v-flex>
									<v-flex xs1>
										<v-btn
											class="error--text ma-0"
											dark
											icon
											small
											@click="removeData('additionalData', index)"
										>
											<img src="/static/img/actions-list/delete.svg" alt="">
										</v-btn>
									</v-flex>
								</v-layout>
							</v-flex>
						</v-layout>
					</v-flex>
					<v-flex xs12 md6>
						<v-layout row wrap>
							<v-flex xs12 py-0>
								<label class="title-section">Módulos Contables</label>
								<small
									class="error-style"
									v-show="$v.$anyDirty && !$v.model.modules.required"
								>(Almenos un módulo contable es requerido)</small>
							</v-flex>
							<v-flex xs12 pt-0 pb-3>
								<v-divider></v-divider>
							</v-flex>
							<v-flex xs12>
								<v-layout row justify-space-between align-start>
									<v-flex xs5>
										<BaseInput
											label="Código"
											:height="38"
											v-model="module.code"
										/>
									</v-flex>
									<v-flex xs5>
										<BaseInput
											label="Nombre"
											:height="38"
											v-model="module.name"
											@keypress.enter="addData('modules')"
										/>
									</v-flex>
									<v-flex xs1>
										<AddButton
											class="add-btn-container mr-2"
											@click="addData('modules')"
										/>
									</v-flex>
								</v-layout>
							</v-flex>
						</v-layout>
						<v-layout wrap align-center justify-space-between>
							<v-flex xs12 style="height:78px"
								v-for="(modelData, index) in model.modules"
								:key="modelData.id">
								<v-layout wrap align-center justify-space-between>
									<v-flex xs5>
										<BaseCheckBox
											:height="38"
											:label="`${modelData.code}-${modelData.name}`"
											:input-value="modelData.flagActive"
											v-model="modelData.flagActive"
										/>
									</v-flex>
									<v-flex xs1>
										<v-btn
											class="error--text ma-0"
											dark
											icon
											small
											@click="removeData('modules', index)"
										>
											<img src="/static/img/actions-list/delete.svg" alt="">
										</v-btn>
									</v-flex>
								</v-layout>
							</v-flex>
						</v-layout>
					</v-flex>
				</v-layout>
				<section class="modal-filter-footer">
					<modal-sidebar-button
						@cancel-button-clicked="closeModal"
						@accept-button-clicked="submitForm"
						:is-loading="disabledCompany"
					>
					</modal-sidebar-button>
				</section>
			</v-form>
		</form-sidebar>
	</div>
</template>

<script>
import { minLength, minValue, required, maxLength } from 'vuelidate/lib/validators';
import appDateMask from '@/components/shared/app-date-mask';
import companyFilter from '@/components/companies/company-filter';
import helper from '@/shared/helper';
import lib from '@/shared/lib';

const PAGE_COMPANY_LIST = 'companies';

function created() {
	if (this.customerId) {
		this.params.customerId = this.customerId;
	}
	this.loadResources();
}

async function addData(type) {
	const copyType = type === 'modules' ? 'module' : type;
	if ((this[copyType].code && this[copyType].name) ||
		(this[copyType].name && this[copyType].value)) {
		if (copyType === 'module') {
			if (this.mode === 'edit') {
				const body = { ...this.module };
				body.subsidiaryId = this.companyId;
				body.customerId = this.params.customerId;
				delete body.flagActive;
				const { data: response } = await this.$http.post('type-register', body);
				const newResponse = {
					code: response.code,
					flagActive: false,
					id: response.id,
					name: response.name,
				};
				this.model.modules.push({ ...newResponse });
				this.showNotification('Módulo agregado correctamente.');
			} else {
				this[copyType].id = this.model[type].length + 1;
				this[copyType].canRemove = true;
				this[copyType].flagActive = true;
				this.model[type].push({ ...this[copyType] });
			}
			this[copyType] = {
				code: '',
				name: '',
			};
		} else {
			this[copyType].id = this.model[type].length + 1;
			this[copyType].canRemove = true;
			this.model[type].push({ ...this[copyType] });
			this[copyType] = {
				name: '',
				value: '',
			};
		}
	} else {
		const messageType = type === 'modules' ? 'módulo' : 'dato adicional';
		this.showGenericError(`Se deben completar los dos campos para poder agregar un ${messageType}`);
	}
}

function closeModal() {
	const { customerName } = this.$route.params;
	this.goTo(
		PAGE_COMPANY_LIST,
		{ params: { customerId: this.customerId, customerName } },
	);
}

function disabledCompany() {
	const modulesValid = this.model.modules.some(mod => mod.flagActive);
	return this.loading || this.externalLoading || this.requiresExternalSelection || !modulesValid;
}

function externalOptionLabel(record) {
	const company = record.company || {};
	const companyName = company.companyName || company.company_name || company.ruc ||
		'Empresa comercial';
	const subsidiaryName = record.sucursalName || record.sucursal_name || record.rzSocial ||
		record.rz_social || 'Sucursal sin nombre';
	return `${companyName} · ${subsidiaryName} · ID ${record.id}`;
}

function getModules(modules) {
	return lib.map(
		lib.setNewProperty('flagActive', ({ flagActive }) => Boolean(flagActive)),
		modules,
	);
}

async function loadCompanyData() {
	const { data: record } = await this.$http.get(
		`subsidiary/${this.companyId}/detail`);
	if (record) {
		this.model = {
			activityId: record.activityId,
			additionalData: record.additionalData || [],
			cityId: record.cityId,
			documentNumber: record.documentNumber,
			externalId: record.externalId,
			legalRepresentative: record.legalRepresentative,
			modules: this.getModules(record.modules),
			name: record.name,
			startDateOperations: helper.exactDate(record.startDateOperations, 'YYYY-MM-DD'),
			typeTaxpayerId: record.typeTaxpayerId,
		};
		this.externalLookupRuc = String(record.documentNumber || '').trim();
		this.valueStartDate = helper.exactDate(record.startDateOperations, 'DD/MM/YYYY');
	}
}

async function loadResources() {
	const request = [
		this.$http.get('activities'),
		this.$http.get('cities'),
		this.$http.get('regimes'),
		this.$http.get('module'),
	];
	[
		{ data: this.activities },
		{ data: this.cities },
		{ data: this.typeTaxpayers },
		{ data: this.model.modules },
	] = await Promise.all(request);
	if (this.mode === 'edit') {
		await this.loadCompanyData();
		await this.setExternalId();
	}
}

function mode() {
	return this.companyId ? 'edit' : 'create';
}

function onDate(value, modelName) {
	this.model[modelName] = value;
}

function removeData(type, index) {
	this.model[type].splice(index, 1);
}

async function submitForm() {
	this.loading = true;
	const method = this.mode === 'create' ? 'post' : 'patch';
	const url = this.mode === 'create' ? `subsidiary/${this.params.customerId}/customer` :
		`subsidiary/${this.companyId}`;
	const newModel = { ...this.model };
	newModel.modules = this.model.modules.map((mod) => {
		const newMod = {
			code: mod.code,
			flagActive: !!mod.flagActive,
			name: mod.name,
		};
		if (this.mode === 'edit') {
			newMod.id = mod.id;
		}
		return newMod;
	});
	newModel.additionalData = this.model.additionalData.map((add) => {
		const newAdd = { ...add };
		delete newAdd.id;
		delete newAdd.canRemove;
		return newAdd;
	});
	try {
		await this.$http[method](url, newModel);
		this.showNotification('La empresa ha sido creada correctamente.');
		this.closeModal();
	} catch (err) {
		if (err.status === 500) {
			this.showGenericError();
		} else if (err.status === 400) {
			if (err.data.message === 'SECTOR_DEFAULT_NOT_FOUND') {
				this.showGenericError('Sector por defecto no encontrado.');
			} else if (err.data.message === 'PLAN_TEMPLATE_NOT_EXIST') {
				this.showGenericError('Plan no existente.');
			} else if (err.data.message === 'CODE_COMPANY_DUPLICATE') {
				this.showGenericError('El número de documento ya está registrado.');
			}
		}
	} finally {
		this.loading = false;
	}
}

function validations() {
	const validation = {
		params: {
			customerId: {
				minValue: minValue(1),
				required,
			},
		},
		model: {
			name: {
				required,
			},
			documentNumber: {
				required,
				maxLength: maxLength(13),
			},
			modules: {
				minLength: minLength(1),
				required,
			},
		},
	};
	return validation;
}

function title() {
	const companyAction = this.companyId ? `Editar > ${this.model.name}` : 'Nueva Empresa';
	return `${this.customerName} > ${companyAction}`;
}

async function setExternalId(event) {
	const eventRuc = event && event.target ? event.target.value : null;
	const ruc = String(eventRuc || this.model.documentNumber || '').trim();
	const previousExternalId = this.model.externalId;
	const sameRuc = ruc === this.externalLookupRuc;
	this.externalOptions = [];
	if (!ruc) {
		this.model.externalId = null;
		this.externalLookupRuc = null;
		return;
	}
	if (!sameRuc) {
		this.model.externalId = null;
	}
	this.externalLoading = true;
	const url = `subsidiaries/${ruc}/ruc-public?all=true`;
	try {
		const { data: externalResponse } = await this.$httpSales.get(url);
		const records = Array.isArray(externalResponse) ? externalResponse : [externalResponse];
		this.externalOptions = records
			.filter(record => record && record.id)
			.map(record => ({
				...record,
				label: externalOptionLabel(record),
			}));
		const previousOption = this.externalOptions.find(
			option => Number(option.id) === Number(previousExternalId),
		);
		if (this.externalOptions.length === 1) {
			this.model.externalId = this.externalOptions[0].id;
		} else if (previousOption) {
			this.model.externalId = previousOption.id;
		} else {
			this.model.externalId = null;
		}
		this.externalLookupRuc = ruc;
		if (this.externalOptions.length > 1 && !this.model.externalId) {
			this.showNotification(
				'Se encontraron varias empresas con este RUC. Selecciona la correcta.',
				'info',
			);
		}
	} catch (error) {
		if (!sameRuc) {
			this.model.externalId = null;
		}
		if (error && error.data && error.data.message === 'SUBSIDIARIES_ERROR') {
			this.showNotification('No existe subsidiaria asociada a ese número de identificación', 'info');
		} else {
			this.showGenericError('No fue posible consultar las empresas comerciales asociadas.');
		}
	} finally {
		this.externalLoading = false;
	}
}

function requiresExternalSelection() {
	return this.externalOptions.length > 1 && !this.model.externalId;
}

function data() {
	return {
		activities: [],
		additionalData: {
			name: '',
			value: '',
		},
		cities: [],
		externalLoading: false,
		externalLookupRuc: null,
		externalOptions: [],
		isLoading: false,
		loading: false,
		model: {
			activityId: null,
			additionalData: [],
			cityId: null,
			documentNumber: null,
			externalId: null,
			legalRepresentative: null,
			modules: [],
			name: null,
			startDateOperations: null,
			typeTaxpayerId: null,
		},
		module: {
			code: '',
			flagActive: false,
			name: '',
		},
		typeTaxpayers: [],
		valueStartDate: null,
	};
}

export default {
	name: 'company-form',
	components: {
		AddButton: () => import('@/components/shared/buttons/add-button'),
		appDateMask,
		BaseCheckBox: () => import('@/components/shared/inputs/base-checkbox'),
		BaseDate: () => import('@/components/shared/inputs/base-date'),
		BaseInput: () => import('@/components/shared/inputs/base-input'),
		BaseSelect: () => import('@/components/shared/inputs/base-select'),
		companyFilter,
	},
	computed: {
		disabledCompany,
		mode,
		requiresExternalSelection,
		title,
	},
	created,
	data,
	methods: {
		addData,
		closeModal,
		loadCompanyData,
		loadResources,
		getModules,
		onDate,
		removeData,
		setExternalId,
		submitForm,
	},
	props: {
		companyId: [Number, String],
		customerName: [Number, String],
		customerId: [Number, String],
	},
	validations,
};
</script>

<style lang="scss" scoped>
.external-company-hint {
	display: block;
	margin-top: 8px;
	line-height: 1.5;
}
	.title-section {
		font-family: map-get($fonts, open-semibold);
		font-size: map-get($sizes, small13);
		padding-left: 9px;
		text-transform: uppercase;
	}

	hr {
		border-color: map-get($colors, grey-divider) !important;
		border-width: 1.5px;
	}

	.error-style {
		color: color(error);
	}

	.form {
		padding-bottom: 40px;
	}
</style>



// WEBPACK FOOTER //
// src/components/companies/company-form.vue